<template>
  <div class="relative flex justify-center items-center p-6">
    <img
      src="/logo-ct-sm.png"
      class="absolute rounded-full animate-ping opacity-25"
      alt="ClockTracker"
    />
    <img
      src="/logo-ct-sm.png"
      class="rounded-full relative z-10 opacity-25"
      alt="ClockTracker"
    />
  </div>
</template>
